import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vShow as _vShow } from "vue";
var _hoisted_1 = {
  class: "date_box"
};
var _hoisted_2 = {
  class: "date_top"
};
var _hoisted_3 = {
  class: "btns"
};
var _hoisted_4 = {
  class: "date_contain"
};
var _hoisted_5 = {
  class: "calendar_header"
};
var _hoisted_6 = {
  class: "now_date"
};
var _hoisted_7 = {
  class: /*@__PURE__*/_normalizeClass(['day'])
};
var _hoisted_8 = {
  class: "day-text"
};
var _hoisted_9 = ["onClick"];
var _hoisted_10 = ["onClick"];
var _hoisted_11 = {
  class: "day-schedules-popover-content"
};
var _hoisted_12 = {
  class: "popover-header"
};
var _hoisted_13 = {
  class: "schedules-list"
};
var _hoisted_14 = ["onClick"];
var _hoisted_15 = {
  class: "schedule-time"
};
var _hoisted_16 = {
  class: "schedule-title"
};
var _hoisted_17 = {
  class: "d_caledar_main"
};
var _hoisted_18 = ["onClick"];
var _hoisted_19 = {
  class: "spacbtn"
};
var _hoisted_20 = {
  class: "timeli"
};
var _hoisted_21 = {
  class: "time"
};
var _hoisted_22 = {
  class: "content"
};
var _hoisted_23 = ["onClick"];
var _hoisted_24 = ["onClick"];
var _hoisted_25 = {
  class: "empty_todo"
};
var _hoisted_26 = {
  style: {
    "display": "flex",
    "width": "100%"
  }
};
var _hoisted_27 = {
  style: {
    "flex": "1"
  }
};
var _hoisted_28 = {
  class: "dialog-footer"
};
var _hoisted_29 = {
  class: "my-header"
};
var _hoisted_30 = ["id"];
var _hoisted_31 = ["onClick"];
var _hoisted_32 = {
  class: "detail_content"
};
import { Plus } from "@element-plus/icons";
import { reactive, watch, ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { get_dictionary, calendar_app, get_Calendar_app, client, statistics_data_module } from "@/api/apis";
import _ from "lodash";
import { ElMessage, ElMessageBox } from "element-plus";
import { getMonthFrist, getMonthLast } from "@/util/index.js";
import { useUserStore } from "@/store/user";
export default {
  __name: 'scheduleCon',
  setup(__props) {
    statistics_data_module({
      module: "linker_work_bench_work_schedule"
    }, "post");
    statistics_data_module({
      module: "linker_work_bench_work_schedule"
    }, "post");
    var userStore = useUserStore();
    var router = useRouter();
    var ruleFormRef = ref(null);
    var calendar = ref(null);
    var dialogFormVisible = ref(false);

    /**
     *登记日程
     */
    var edit_id = ref(0);
    var edit_info = ref("");
    var is_show_dialog_visit = ref(false);
    var handle_close = () => {
      is_show_dialog_visit.value = false;
    };
    var handle_success = () => {
      router.push("/work_bench/visit");
    };
    var handle_registration = item => {
      if (item.plan_status != 1) {
        ElMessage({
          type: "warning",
          message: "已完成登记"
        });
        return false;
      }
      edit_info.value = item;
      is_show_dialog_visit.value = true;
    };
    var handle_delete = item => {
      ElMessageBox.confirm("确定要删除此日程?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        calendar_app({
          id: item.id
        }, "delete").then(res => {
          if (res.code == 200) {
            ElMessage({
              type: "success",
              message: "删除成功"
            });
            getlist();
          }
        });
      }).catch(() => {});
    };
    var rules = ref({
      title: [{
        required: true,
        message: "请输入标题",
        trigger: "blur"
      }],
      start_time: [{
        required: true,
        message: "开始时间不能为空",
        trigger: ["blur", "change"]
      }],
      end_time: [{
        required: true,
        message: "结束时间不能为空",
        trigger: ["blur", "change"]
      }]
    });
    var default_form = {
      title: "",
      start_time: "",
      end_time: "",
      client_name: "",
      // 客户
      client_id: "",
      client_contacts: "",
      // 联系人
      visit_way: "",
      wait_type: "",
      address_remark: "",
      // 地址
      content: "",
      // 议题
      remark: "",
      // 备注
      calendar_type: 1,
      // 1：普通日程 2:共享日程
      at_user_ids: [] // 共享人员改为数组
    };
    var form = ref(Object.assign({}, default_form));
    var share_list = ref([]);
    var isEdit = ref(false);
    userStore.get_user_list_fn().then(res => {
      share_list.value = res;
    });
    var handleAdd = () => {
      isEdit.value = false;
      form.value = Object.assign({}, default_form);
      client_contracts_list.value = [];
      dialogFormVisible.value = true;
    };
    var onSubmit = () => {
      ruleFormRef.value.validate(valid => {
        if (valid) {
          if (form.value.start_time && form.value.end_time) {
            var startTime = new Date(form.value.start_time).getTime();
            var endTime = new Date(form.value.end_time).getTime();
            if (startTime > endTime) {
              ElMessage.error("开始时间不能晚于结束时间");
              return;
            }
          }
          var obj = _.cloneDeep(form.value);
          obj.end_time = obj.end_time && obj.end_time.getTime() / 1000;
          obj.start_time = obj.start_time && obj.start_time.getTime() / 1000;
          if (obj.calendar_type == 2) {
            obj.at_user_ids = Array.isArray(obj.at_user_ids) ? obj.at_user_ids.join(",") : "";
          } else {
            delete obj.at_user_ids;
          }
          var method = "post";
          if (isEdit.value) {
            method = "put";
            obj.id = current_todo_detail.value ? current_todo_detail.value.id : null;
          }
          calendar_app(obj, method).then(res => {
            if (res.code == 200) {
              ElMessage({
                type: "success",
                message: isEdit.value ? "日程编辑成功" : "日程添加成功"
              });
              getlist();
              dialogFormVisible.value = false;
              show_todo_dialog.value = false;
            }
          });
        }
      });
    };
    var date_String = val => {
      if (val) {
        var date = new Date(val * 1000);
        return (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":" + (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes());
      }
    };
    var data_String_l = val => {
      if (val) {
        var date = new Date(val * 1000);
        return date.toLocaleString();
      }
    };

    // 判断是否为当天日期
    var isToday = dateStr => {
      var today = new Date();
      var year = today.getFullYear();
      var month = String(today.getMonth() + 1).padStart(2, "0");
      var day = String(today.getDate()).padStart(2, "0");
      var todayStr = "".concat(year, "-").concat(month, "-").concat(day);
      return dateStr === todayStr;
    };

    /**
     * 计算当前的日程（用于下方显示）
     */
    var get_todo_list = day => {
      if (!day) {
        return [];
      }
      var v = "-";
      if (day.indexOf("/") != -1) {
        v = "/";
      }
      var days = day.split(v);
      if (days && days.length == 3) {
        var now_time = new Date(days[0], days[1] - 1, days[2]) / 1000;
        if (data_thing_list.value && data_thing_list.value.length != 0) {
          var arr = data_thing_list.value.filter(x => {
            return x.start_time <= now_time && now_time <= x.end_time || new Date(x.start_time * 1000).toLocaleDateString() == new Date(now_time * 1000).toLocaleDateString();
          });
          return [...arr];
        } else {
          return [];
        }
      } else {
        return [];
      }
    };

    // 查看日程详情
    var show_todo_dialog = ref(false);
    var current_todo_detail = ref({});
    var handleShowDetail = item => {
      show_todo_dialog.value = true;
      current_todo_detail.value = item;
    };

    // 编辑日程详情
    var handle_edit = () => {
      var info = _.cloneDeep(current_todo_detail.value);
      dialogFormVisible.value = true;
      isEdit.value = true;
      Object.keys(form.value).map(x => {
        if (info[x]) {
          form.value[x] = info[x];
        }
      });
      client({
        company: form.value.client_name
      }).then(res => {
        if (res.code == 200 && form.value.client_name) {
          client_contracts_list.value = res.data.list[0].client_users;
        }
      });
      form.value.start_time = new Date(form.value.start_time * 1000);
      form.value.end_time = new Date(form.value.end_time * 1000);
    };

    // 切换时间
    var selectDate = val => {
      if (!calendar.value) return;
      calendar.value.selectDate(val);
    };

    // 添加跳转到今日的方法
    var goToToday = () => {
      time_date.value = new Date();
    };

    /**
     * 筛选
     */
    var data_type = ref(""); // 进行选择数据的字段
    var is_show_dialog = ref(false);
    var client_contracts_list = ref([]);
    var select_data = val => {
      data_type.value = val;
      is_show_dialog.value = true;
    };
    var get_select_item = val => {
      is_show_dialog.value = false;
      if (data_type.value == "客户") {
        if (val.company != form.value.client_name) {
          form.value.client_name = val.company;
          form.value.client_id = val.id;
          form.value.client_contacts = "";
          client_contracts_list.value = val.client_users || [];
        }
      }
    };

    /**
     * 选择的时间
     */
    var time_date = ref(new Date());
    var data_thing_list = ref([]);
    var search_start_time = ref("");
    var search_end_time = ref("");
    var getlist = () => {
      get_Calendar_app({
        start_time: search_start_time.value,
        end_time: search_end_time.value
      }).then(res => {
        if (res.code == 200) {
          data_thing_list.value = [...res.data.data];
        }
      });
    };
    //还有几项行程
    var handleShowDaySchedules = day => {
      time_date.value = new Date(day.replace(/-/g, "/"));
    };
    var formatPopoverDate = dateStr => {
      var date = new Date(dateStr.replace(/-/g, '/'));
      return date.toLocaleDateString('zh-CN', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        weekday: 'short'
      });
    };

    // 获取指定日期的显示日程（保持固定位置）
    var get_display_schedules_for_day = day => {
      if (!day || !data_thing_list.value || data_thing_list.value.length === 0) {
        return [];
      }
      var v = "-";
      if (day.indexOf("/") != -1) {
        v = "/";
      }
      var days = day.split(v);
      if (days && days.length == 3) {
        var checkDate = new Date(days[0], days[1] - 1, days[2]);
        var checkDateStr = checkDate.toLocaleDateString();

        // 按开始时间对日程进行全局排序
        var globalSortedSchedules = [...data_thing_list.value].sort((a, b) => {
          // 首先按开始时间排序
          if (a.start_time !== b.start_time) {
            return a.start_time - b.start_time;
          }
          // 开始时间相同，按标题排序
          return (a.title || "").localeCompare(b.title || "");
        });

        // 用于存储要显示的日程
        var displaySchedules = [];

        // 检查每个日程是否应该在该日期显示
        var _loop = function _loop() {
          var startDate = new Date(schedule.start_time * 1000);
          var endDate = new Date(schedule.end_time * 1000);
          var startDateStr = startDate.toLocaleDateString();
          var endDateStr = endDate.toLocaleDateString();

          // 检查日程是否覆盖这一天
          var coversThisDay = startDateStr === checkDateStr || endDateStr === checkDateStr || startDate < checkDate && checkDate < endDate;
          if (coversThisDay) {
            // 获取该日程在全局排序中的位置
            var globalIndex = globalSortedSchedules.indexOf(schedule);

            // 检查是否已经有日程占用了这个显示位置
            var positionOccupied = displaySchedules.some(item => item.displayIndex === globalIndex);
            if (!positionOccupied) {
              var displayText = schedule.title;

              // 如果是跨日日程的中间日期，可以显示不同的内容
              if (startDate < checkDate && checkDate < endDate) {
                // 中间日期可以显示标题或简单标识
                displayText = schedule.title; // 或使用 "●" 表示延续
              }
              displaySchedules.push({
                originalItem: schedule,
                displayText: displayText,
                displayIndex: globalIndex
              });
            }
          }
        };
        for (var schedule of globalSortedSchedules) {
          _loop();
        }

        // 按显示索引排序并限制显示数量
        return displaySchedules.sort((a, b) => a.displayIndex - b.displayIndex).slice(0, 2); // 最多显示2条
      }
      return [];
    };

    // 获取指定日期的日程列表（用于显示数量提示）
    var get_todo_list_for_day = day => {
      if (!day) {
        return [];
      }
      var v = "-";
      if (day.indexOf("/") != -1) {
        v = "/";
      }
      var days = day.split(v);
      if (days && days.length == 3) {
        var now_time = new Date(days[0], days[1] - 1, days[2]) / 1000;
        if (data_thing_list.value && data_thing_list.value.length != 0) {
          var arr = data_thing_list.value.filter(x => {
            var startDate = new Date(x.start_time * 1000);
            var endDate = new Date(x.end_time * 1000);
            var checkDate = new Date(now_time * 1000);
            var startDateStr = startDate.toLocaleDateString();
            var checkDateStr = checkDate.toLocaleDateString();
            return startDateStr === checkDateStr || x.start_time <= now_time && now_time <= x.end_time;
          });
          return arr;
        } else {
          return [];
        }
      } else {
        return [];
      }
    };
    watch(() => time_date.value, val => {
      if (val) {
        search_start_time.value = getMonthFrist(time_date.value) / 1000;
        search_end_time.value = getMonthLast(time_date.value) / 1000;
        getlist();
      }
    }, {
      immediate: true
    });
    watch(() => dialogFormVisible.value, val => {
      if (!val) {
        form.value = Object.assign({}, default_form);
        client_contracts_list.value = [];
        if (ruleFormRef.value && ruleFormRef.value.resetFields) {
          ruleFormRef.value.resetFields();
        }
      }
    });

    /**
     * 数据字典
     */
    var dic_data = reactive({
      visitList: [],
      waitList: []
    });
    get_dictionary({
      full_name: "拜访方式"
    }).then(res => {
      if (res.code == 200) {
        dic_data.visitList = res.data.data;
      }
    });
    get_dictionary({
      full_name: "待办类型"
    }).then(res => {
      if (res.code == 200) {
        dic_data.waitList = res.data.data;
      }
    });

    // 组件挂载时获取用户列表
    onMounted(() => {
      userStore.get_user_list_fn().then(res => {
        share_list.value = res;
      });
    });
    return (_ctx, _cache) => {
      var _component_el_button = _resolveComponent("el-button");
      var _component_el_popover = _resolveComponent("el-popover");
      var _component_el_calendar = _resolveComponent("el-calendar");
      var _component_el_tooltip = _resolveComponent("el-tooltip");
      var _component_empty = _resolveComponent("empty");
      var _component_el_input = _resolveComponent("el-input");
      var _component_el_form_item = _resolveComponent("el-form-item");
      var _component_el_col = _resolveComponent("el-col");
      var _component_el_row = _resolveComponent("el-row");
      var _component_el_date_picker = _resolveComponent("el-date-picker");
      var _component_el_option = _resolveComponent("el-option");
      var _component_el_select = _resolveComponent("el-select");
      var _component_el_form = _resolveComponent("el-form");
      var _component_el_dialog = _resolveComponent("el-dialog");
      var _component_select_data = _resolveComponent("select-data");
      var _component_add_visit_dailog = _resolveComponent("add-visit-dailog");
      var _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[21] || (_cache[21] = _createElementVNode("div", null, [_createElementVNode("span", {
        style: {
          "cursor": "pointer",
          "padding-right": "12px"
        }
      }, [_createTextVNode("   "), _createElementVNode("span", {
        class: "iconfont icon-richeng1"
      }), _createTextVNode("  "), _createElementVNode("span", null, "我的日程")])], -1)), _createElementVNode("div", _hoisted_3, [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
        type: "primary",
        icon: _unref(Plus),
        color: "#02204c",
        size: "small",
        onClick: handleAdd
      }, {
        default: _withCtx(() => _cache[20] || (_cache[20] = [_createTextVNode("新建日程")])),
        _: 1
      }, 8, ["icon"])), [[_directive_permission, '600::301']])])]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_calendar, {
        modelValue: time_date.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => time_date.value = $event),
        ref_key: "calendar",
        ref: calendar
      }, {
        header: _withCtx(_ref => {
          var {
            date
          } = _ref;
          return [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("span", {
            class: "iconfont icon-zuojiantou",
            onClick: _cache[0] || (_cache[0] = $event => selectDate('prev-month'))
          }), _createTextVNode(" " + _toDisplayString(date) + " ", 1), _createElementVNode("span", {
            class: "iconfont icon-youjiantou",
            onClick: _cache[1] || (_cache[1] = $event => selectDate('next-month'))
          })]), _createElementVNode("div", {
            class: "today-btn",
            onClick: goToToday
          }, "今日")])];
        }),
        "date-cell": _withCtx(_ref2 => {
          var {
            data
          } = _ref2;
          return [_createElementVNode("div", {
            class: _normalizeClass(['d_day', isToday(data.day) ? 'today' : '', data.isSelected ? 'is-selected' : ''])
          }, [_createElementVNode("p", _hoisted_7, [_createElementVNode("span", _hoisted_8, _toDisplayString(data.day.split("-")[2]), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(get_display_schedules_for_day(data.day), (item, index) => {
            return _openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(['schedule-item']),
              onClick: _withModifiers($event => handleShowDetail(item.originalItem), ["stop"])
            }, [_createElementVNode("span", null, _toDisplayString(item.displayText), 1)], 8, _hoisted_9);
          }), 128)), get_todo_list_for_day(data.day).length > 2 ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "more-schedules",
            onClick: _withModifiers($event => handleShowDaySchedules(data.day), ["stop"])
          }, [_createVNode(_component_el_popover, {
            placement: "right",
            width: 400,
            trigger: "hover",
            "popper-class": 'day-schedules-popover'
          }, {
            reference: _withCtx(() => [_createElementVNode("span", null, "还有" + _toDisplayString(get_todo_list_for_day(data.day).length - 2) + " 项", 1)]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, _toDisplayString(formatPopoverDate(data.day)), 1), _createElementVNode("ul", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(get_todo_list_for_day(data.day), (item, index) => {
              return _openBlock(), _createElementBlock("li", {
                key: index,
                class: "schedule-item-row",
                onClick: $event => handleShowDetail(item)
              }, [_createElementVNode("div", _hoisted_15, _toDisplayString(data_String_l(item.start_time)) + "   -   " + _toDisplayString(data_String_l(item.end_time)), 1), _createElementVNode("div", _hoisted_16, _toDisplayString(item.title), 1)], 8, _hoisted_14);
            }), 128))])])]),
            _: 2
          }, 1024)], 8, _hoisted_10)) : _createCommentVNode("", true)], 2)];
        }),
        _: 1
      }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_17, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(get_todo_list(time_date.value.toLocaleDateString()), (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          key: index,
          class: "day_todo",
          onClick: _withModifiers($event => handleShowDetail(item), ["stop"])
        }, [_cache[22] || (_cache[22] = _createElementVNode("span", {
          class: "iconfont icon-shipin1",
          style: {
            "color": "#1d96cf",
            "margin-right": "4px",
            "transform": "scale(0.8)"
          }
        }, null, -1)), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, _toDisplayString(data_String_l(item.start_time)) + "   -   " + _toDisplayString(data_String_l(item.end_time)), 1), _createElementVNode("div", _hoisted_22, _toDisplayString(item.title), 1)]), _createElementVNode("div", null, [_createVNode(_component_el_tooltip, {
          class: "box-item",
          effect: "dark",
          content: "删除此日程",
          placement: "top"
        }, {
          default: _withCtx(() => [_withDirectives(_createElementVNode("span", {
            class: "iconfont icon-shanchu",
            style: {
              "font-size": "20px"
            },
            onClick: _withModifiers($event => handle_delete(item), ["stop"])
          }, null, 8, _hoisted_23), [[_directive_permission, '600::302']])]),
          _: 2
        }, 1024), _createVNode(_component_el_tooltip, {
          class: "box-item",
          effect: "dark",
          content: "登记此日程",
          placement: "top"
        }, {
          default: _withCtx(() => [_createElementVNode("span", {
            class: _normalizeClass(['iconfont', 'icon-complete', item.plan_status == 1 ? 'doing' : 'finish']),
            onClick: _withModifiers($event => handle_registration(item), ["stop"])
          }, null, 10, _hoisted_24)]),
          _: 2
        }, 1024)])])], 8, _hoisted_18);
      }), 128)), _withDirectives(_createElementVNode("div", _hoisted_25, [_createVNode(_component_empty, {
        msg: "暂无待办事项"
      })], 512), [[_vShow, get_todo_list(time_date.value.toLocaleDateString()).length == 0]])])])]), _createVNode(_component_el_dialog, {
        modelValue: dialogFormVisible.value,
        "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => dialogFormVisible.value = $event),
        title: isEdit.value ? '编辑日程' : '新增日程',
        style: {
          "width": "700px"
        }
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_28, [_createVNode(_component_el_button, {
          onClick: _cache[16] || (_cache[16] = $event => dialogFormVisible.value = false)
        }, {
          default: _withCtx(() => _cache[24] || (_cache[24] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: onSubmit,
          color: "#248f83"
        }, {
          default: _withCtx(() => _cache[25] || (_cache[25] = [_createTextVNode(" 确认 ")])),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: form.value,
          "label-position": "top",
          ref_key: "ruleFormRef",
          ref: ruleFormRef,
          rules: rules.value
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, {
            gutter: 20
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "标题",
                prop: "title"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.title,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.title = $event),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, {
            gutter: 20
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "开始时间",
                prop: "start_time"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                  modelValue: form.value.start_time,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.value.start_time = $event),
                  type: "datetime",
                  placeholder: "请输入开始时间",
                  format: "YYYY-MM-DD HH:mm",
                  style: {
                    "width": "100%"
                  }
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "结束时间",
                prop: "end_time"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                  modelValue: form.value.end_time,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.value.end_time = $event),
                  type: "datetime",
                  style: {
                    "width": "100%"
                  },
                  format: "YYYY-MM-DD HH:mm",
                  placeholder: "请输入结束时间"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, {
            gutter: 20
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "客户"
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createVNode(_component_el_input, {
                  modelValue: form.value.client_name,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.value.client_name = $event),
                  autocomplete: "off",
                  disabled: "",
                  style: {
                    "width": "100%"
                  }
                }, null, 8, ["modelValue"])]), _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[7] || (_cache[7] = $event => select_data('客户')),
                  color: "#248f83",
                  style: {
                    "margin-left": "10px"
                  }
                }, {
                  default: _withCtx(() => _cache[23] || (_cache[23] = [_createTextVNode("选择")])),
                  _: 1
                })])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "联系人"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: form.value.client_contacts,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => form.value.client_contacts = $event),
                  class: "m-2",
                  placeholder: "",
                  filterable: "",
                  style: {
                    "width": "100%"
                  }
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(client_contracts_list.value, item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.name,
                      value: item.name
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, {
            gutter: 20
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "拜访方式"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: form.value.visit_way,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => form.value.visit_way = $event),
                  class: "m-2",
                  placeholder: "",
                  filterable: "",
                  style: {
                    "width": "100%"
                  }
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dic_data.visitList, item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.full_name,
                      value: item.full_name
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "待办类型"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: form.value.wait_type,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => form.value.wait_type = $event),
                  class: "m-2",
                  placeholder: "",
                  filterable: "",
                  style: {
                    "width": "100%"
                  }
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dic_data.waitList, item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.full_name,
                      value: item.full_name
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _withDirectives(_createVNode(_component_el_row, {
            gutter: 20
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "地址"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.address_remark,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => form.value.address_remark = $event),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }, 512), [[_vShow, form.value.visit_way == '上门拜访']]), _createVNode(_component_el_row, {
            gutter: 20
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "议题"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: form.value.content,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => form.value.content = $event),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, {
            gutter: 20
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "备注"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  type: "textarea",
                  modelValue: form.value.remark,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => form.value.remark = $event),
                  autocomplete: "off",
                  rows: 3
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, {
            gutter: 20
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "日程类型"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: form.value.calendar_type,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => form.value.calendar_type = $event),
                  class: "m-2",
                  placeholder: "",
                  filterable: "",
                  style: {
                    "width": "100%"
                  }
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_option, {
                    label: "普通日程",
                    value: 1
                  }), _createVNode(_component_el_option, {
                    label: "共享类型",
                    value: 2
                  })]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _withDirectives(_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "共享人员"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: form.value.at_user_ids,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => form.value.at_user_ids = $event),
                  class: "m-2",
                  placeholder: "",
                  filterable: "",
                  multiple: "",
                  style: {
                    "width": "100%"
                  }
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(share_list.value, item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.name,
                      value: item.id
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }, 512), [[_vShow, form.value.calendar_type == 2]])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["modelValue", "title"]), _createVNode(_component_el_dialog, {
        modelValue: show_todo_dialog.value,
        "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => show_todo_dialog.value = $event),
        "show-close": false,
        style: {
          "width": "700px"
        }
      }, {
        header: _withCtx(_ref3 => {
          var {
            close,
            titleId,
            titleClass
          } = _ref3;
          return [_createElementVNode("div", _hoisted_29, [_createElementVNode("h4", {
            id: titleId,
            class: _normalizeClass(titleClass)
          }, "日程详情", 10, _hoisted_30), _withDirectives(_createElementVNode("span", {
            class: "iconfont icon-bianjisekuai",
            onClick: handle_edit
          }, null, 512), [[_directive_permission, '600::303']]), _createElementVNode("span", {
            class: "iconfont icon-guanbi2fill",
            onClick: close
          }, null, 8, _hoisted_31)])];
        }),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_32, [_createElementVNode("li", null, [_cache[26] || (_cache[26] = _createElementVNode("span", null, "时间：", -1)), _cache[27] || (_cache[27] = _createTextVNode()), _createElementVNode("span", null, _toDisplayString(current_todo_detail.value.time_section), 1)]), _createElementVNode("li", null, [_cache[28] || (_cache[28] = _createElementVNode("span", null, "主题：", -1)), _createElementVNode("span", null, _toDisplayString(current_todo_detail.value.title), 1)]), _createElementVNode("li", null, [_cache[29] || (_cache[29] = _createElementVNode("span", null, "拜访方式：", -1)), _createElementVNode("span", null, _toDisplayString(current_todo_detail.value.visit_way), 1)]), _withDirectives(_createElementVNode("li", null, [_cache[30] || (_cache[30] = _createElementVNode("span", null, "拜访方式：", -1)), _createElementVNode("span", null, _toDisplayString(current_todo_detail.value.address_remark), 1)], 512), [[_vShow, current_todo_detail.value.visit_way == '上门拜访']]), _createElementVNode("li", null, [_cache[31] || (_cache[31] = _createElementVNode("span", null, "客户：", -1)), _createElementVNode("span", null, _toDisplayString(current_todo_detail.value.client_name), 1)]), _createElementVNode("li", null, [_cache[32] || (_cache[32] = _createElementVNode("span", null, "联系人：", -1)), _createElementVNode("span", null, _toDisplayString(current_todo_detail.value.client_contacts), 1)]), _createElementVNode("li", null, [_cache[33] || (_cache[33] = _createElementVNode("span", null, "待办类型：", -1)), _createElementVNode("span", null, _toDisplayString(current_todo_detail.value.wait_type), 1)]), _createElementVNode("li", null, [_cache[34] || (_cache[34] = _createElementVNode("span", null, "议题：", -1)), _createElementVNode("span", null, _toDisplayString(current_todo_detail.value.content), 1)]), _createElementVNode("li", null, [_cache[35] || (_cache[35] = _createElementVNode("span", null, "备注：", -1)), _createElementVNode("span", null, _toDisplayString(current_todo_detail.value.remark), 1)])])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_select_data, {
        onClose: _cache[19] || (_cache[19] = $event => is_show_dialog.value = false),
        isShow: is_show_dialog.value,
        data_type: data_type.value,
        onOnSelectItem: get_select_item
      }, null, 8, ["isShow", "data_type"]), _createVNode(_component_add_visit_dailog, {
        title: "日程登记",
        isShow: is_show_dialog_visit.value,
        onClose: handle_close,
        onOnSetSuccess: handle_success,
        id: edit_id.value,
        info: edit_info.value
      }, null, 8, ["isShow", "id", "info"])], 64);
    };
  }
};